import './gridList.scss';

import React, { HTMLProps } from 'react';

export interface GridListProps extends HTMLProps<HTMLDivElement> {
  title: string;
  items: React.ReactElement[];
}

export const GridList = ({ title, items }: GridListProps) => {
  return (
    <div className="grid-list-container">
      <div className="modal-list-header">{title}</div>
      <div>
        <ul className="modal-result-list">
          {items.map((item) => <li className="modal-list-item" key={item.key}>
            {item}
          </li>)}
        </ul>
      </div>
    </div>
  );
};
